<template>
  <Modal
    :value="internalShow"
    @input="internalShow = $event"
    :max-width="maxWidthPx"
    content-class="error-dialog-content"
    :show-close-button="false"
    :persistent="persistent"
  >
    <template #header>
      <div class="d-flex align-center text-left">
        <v-icon color="error" class="mr-2">mdi-alert-circle</v-icon>
        <Typography variant="h-5 text-left">
          {{ title }}
        </Typography>
      </div>
    </template>
    <Typography
      v-if="message"
      variant="body-1"
      class="text-left black--text pt-4"
      style="white-space: pre-line"
    >
      {{ message }}
    </Typography>
    <slot />
    <div class="d-flex justify-end pt-4">
      <Button v-if="showCancelButton" text @click="handleCancel">
        {{ cancelButtonText }}
      </Button>
      <Button text @click="handleConfirm">
        {{ confirmButtonText }}
      </Button>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/generic/Modal.vue";
import Typography from "@/components/generic/Typography.vue";
import Button from "@/components/generic/Button.vue";

export default {
  name: "ErrorDialogV2",
  components: {
    Modal,
    Typography,
    Button,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      default: "",
    },
    confirmButtonText: {
      type: String,
      default: "Okay",
    },
    cancelButtonText: {
      type: String,
      default: "Cancel",
    },
    showCancelButton: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: [String, Number],
      default: 445,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    internalShow: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    maxWidthPx() {
      if (typeof this.maxWidth === "number") {
        return `${this.maxWidth}px`;
      }
      return this.maxWidth;
    },
  },
  methods: {
    handleConfirm() {
      this.$emit("confirm");
      this.internalShow = false;
    },
    handleCancel() {
      this.$emit("cancel");
      this.internalShow = false;
    },
  },
};
</script>

<style scoped>
.error-dialog-content {
  gap: 0;
}
</style>
